import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AdminLayout from "../components/AdminLayout";
import { getTourFacets, TourCategory } from "@/lib/tours";

// Categories are a fixed domain enum (not editable). This page shows each with
// its live Active-tour count.
const CATEGORIES: { category: TourCategory; nameKey: string; slug: string; icon: string }[] = [
  { category: TourCategory.Adventure, nameKey: "admin.cat.adventure", slug: "aventura", icon: "ri-landscape-line" },
  { category: TourCategory.Cultural, nameKey: "admin.cat.cultural", slug: "cultural", icon: "ri-building-line" },
  { category: TourCategory.Gastronomic, nameKey: "admin.cat.gastronomic", slug: "gastronomico", icon: "ri-restaurant-line" },
  { category: TourCategory.Transport, nameKey: "admin.cat.transport", slug: "transporte", icon: "ri-car-line" },
  { category: TourCategory.Housing, nameKey: "admin.cat.housing", slug: "hospedaje", icon: "ri-home-4-line" },
  { category: TourCategory.Fishing, nameKey: "admin.cat.fishing", slug: "pesca", icon: "ri-ship-line" },
];

export default function AdminCategoriasPage() {
  const { t } = useTranslation("admin");
  const [counts, setCounts] = useState<Record<number, number>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getTourFacets()
      .then((f) => {
        if (cancelled) return;
        const map: Record<number, number> = {};
        f.categories.forEach((c) => { map[c.category] = c.count; });
        setCounts(map);
      })
      .catch(() => { if (!cancelled) setCounts({}); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <AdminLayout title={t("admin.cat.title")}>
      <p className="text-sm text-gray-500 mb-4">{t("admin.cat.desc")}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {CATEGORIES.map((c) => (
          <div key={c.category} className="bg-white rounded-2xl border border-gray-100 p-5">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-ocean/10 text-ocean">
                <i className={`${c.icon} text-lg`} />
              </div>
              <div>
                <h3 className="text-sm font-semibold text-charcoal">{t(c.nameKey)}</h3>
                <p className="text-xs text-gray-400">/{c.slug}</p>
              </div>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-xs text-gray-500">{loading ? "…" : `${counts[c.category] ?? 0} ${t("admin.cat.tours")}`}</span>
              <Link to={`/categoria/${c.slug}`} className="text-xs text-ocean hover:underline">{t("admin.cat.viewTours")}</Link>
            </div>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
